(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/result/result-sport.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/result/result-sport.js');

'use strict';

const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  Loader
} = svs.components.ReactLoader;
const {
  ReactCard: {
    Card,
    CardBody
  },
  ReactForm: {
    Select,
    Option
  }
} = svs.ui;
const ResultChart = svs.grassroots.components.result.ResultChart;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const ResultSport = _ref => {
  let {
    cms,
    currentSport,
    setCurrentSport,
    sports
  } = _ref;
  const response = grassrootsQueryApi.useFetchResultSportQuery(currentSport.name);
  const getChartDataSport = () => ({
    categories: response.data.records.map(year => year.year),
    values: response.data.records.map(year => year.amount)
  });
  if (response.isError) {
    return React.createElement(ErrorDialog, null);
  }
  if (response.isLoading) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  return React.createElement("div", null, React.createElement(Select, {
    label: cms.sportResult.dropdownSport,
    onChange: setCurrentSport,
    v2: true,
    value: currentSport.name
  }, sports.map(sport => React.createElement(Option, {
    key: sport.id,
    name: sport,
    value: sport.name
  }, sport.name))), response.isLoading && React.createElement(Loader, {
    size: 300
  }), response.isSuccess && React.createElement("div", null, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "margin-top-1"
  }, React.createElement(CardBody, null, React.createElement(ResultChart, {
    data: getChartDataSport(),
    title: "".concat(cms.sportResult.payoutHeading, " ").concat(currentSport.name.toLowerCase())
  })))));
};
svs.grassroots.components.result.ResultSport = ResultSport;

 })(window);